import { forwardRef } from "react";
import { AgGridReact } from "ag-grid-react";
import K from "../../../utilities/constants";
import { useDataGrid } from "../../../hooks/useDataGrid/useDataGrid";

export const ClientSideDataGrid = forwardRef(
  (
    {
      userId,
      configKey,
      defaultColumnConfig,
      rowData,
      children,
      tableWrapper = (children) => children,
      ...props
    },
    ref,
  ) => {
    const gridParams = useDataGrid(userId, configKey, defaultColumnConfig);

    const onSortChanged = (params) => {
      props.onSortChanged?.(params);
      gridParams.onSortChanged(params);
    };

    return (
      <div
        className="ag-theme-alpine s2-theme-style"
        style={{
          height: props.height || 735,
          minHeight: props.minHeight,
        }}
      >
        {tableWrapper(
          <AgGridReact
            {...K.AgGridTable.DefaultProps}
            {...gridParams}
            {...props}
            onSortChanged={onSortChanged}
            ref={ref}
            rowData={rowData}
            suppressLoadingOverlay
            rowModelType="clientSide"
            getRowId={null}
          />,
        )}
        {children}
      </div>
    );
  },
);
